<template src='./SensorAddUpdate.html'></template>
<script>
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("driver");
import FileUpload from "./FileUpload.vue";
import FormGenerator from "@/components/Fields/FormGenerator";
export default {
  components: {
    FileUpload,
    FormGenerator,
  },
  data: function () {
    return {
      add: this.$route.params.add,
      deviceData: {},
      code: null,
      name: null,
      purchaseDate: null,
      vendorName: null,
      sensor: null,
      expand: true,
      sensorType: null,
    };
  },
  methods: {
    goToListPage: function () {
      this.$store.commit("sensor/cancel");
      this.$router.push({ name: "sensorLanding" });
    },
    clearEntries: function () {
      this.vendorName = null;
      this.name = null;
    },
    handleChange(event) {
      this.gender = event.value.val;
    },
    handleChangeVendor(event) {
      this.vendorName = event.value.id;
    },
    addDriver: function () {
      console.log('Adding sensor ::: ', this.name);
      if (
        this.name 
      ) {
        this.sensorData = {
          // code: this.code,
          // tenantId: "1",
          name: this.name,
          // badgeNumber: this.badgeNumber,
          // driverPCC: this.driverPCC,
          // cardNum: this.cardNum,
        };
        if (this.add) {
          this.$store
            .dispatch("sensor/addSensor", this.sensorData)
            .then(() => {
              notify(MESSAGES.RECORD_CREATE_SUCCESS);
            })
            .catch(notifyApiError);
          setTimeout(() => {
            this.goToListPage();
            this.clearEntries();
          }, 2000);
        } else {
          this.$store
            .dispatch("sensor/updateSensor", this.sensorData)
            .then(() => {
              notify(MESSAGES.CHANGES_SAVE_SUCCESS);
            })
            .catch(notifyApiError);
          setTimeout(() => {
            this.goToListPage();
            this.clearEntries();
          }, 2000);
        }
      }
    },
    async getDataOnload() {
      // await this.$store.dispatch("loadVendors", null, { root: true });
      await this.$store.dispatch("driver/getColumn");
    },
    expandPanel() {
      let header = document.querySelectorAll('#panelbar .k-header');
      let element = document.querySelectorAll('#panelbar .k-content')[0];
      element.setAttribute('style','display:block !important');
      header[0].addEventListener('click', () => {
      if(element.getAttribute('style') == "display: block;") {
      element.setAttribute('style','display:none !important');
      }
      });
      },
    },
  mounted() {
    this.expandPanel();
  },
  computed: {
    vendorList() {
      return this.$store.state.vendors;
    },
    ...mapState({
      formData: (state) => state.metadata,
      schema: (state) => state.additionalDetails,
    }),
    ...mapGetters(['getFilteredSensors'])
  },
  beforeMount() {
    this.getDataOnload();
    if (!this.$route.params.add) {
      this.title = "Update Device";
      // this.deviceEditData = this.$store.getters["driver/drvr"];
      this.deviceEditData = this.$store.getters["sensor/getEditSensor"];
      this.code = this.deviceEditData.id;
      this.name = this.deviceEditData.name;
      // this.vendorName = this.vendorList.find(
      //   (obj) => obj.id == this.deviceEditData.vendorID
      // );
      console.log("NAME OF THE ##DEVICE : ", this.name);
    } else {
      this.title = "Add Device";
    }
  },
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
.k-form, .k-form-inline {
    font-size: 1rem;
    line-height: 1.5;
    padding: 1rem !important;
}
.page-header .title-text {
    font-size: 12px;
    margin-left: 10px;
}
.mobile_side_lbl{width: 70% !important;}
.mobile_side_btn{display: flex;}
.driver_header_mobile{flex-direction: row !important; overflow-x: auto;padding: 10px 10px 10px 10px;}
}
</style>